// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"b6438dff","145":"b6438dff","149":"6b785715","206":"21460524","226":"fb4a04ac","693":"8cd2e40b"}[chunkId] + ".chunk.css";
};